export function openGenerateTemplateModal() {
  const modal = document.getElementById("variantRemixAiModal");
  if (modal && modal.getAttribute("data-generate-template-open") === "true") {
    $(modal).modal("show");
  }
}
